import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { TrainingDomainsContentRoutingModule } from './training-domains-content-routing.module';
import { TrainingDomainsContentListComponent } from './training-domains-content-list/training-domains-content-list.component';
import { TrainingDomainsContentCreateComponent } from './training-domains-content-create/training-domains-content-create.component';

@NgModule({
  declarations: [TrainingDomainsContentListComponent, TrainingDomainsContentCreateComponent],
  imports: [
    CommonModule,
    TrainingDomainsContentRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class TrainingDomainsContentModule { }
